<template>
  <section 
    id="section-logos" 
    class="n-page-section n-breakout "
    :style="sectionStyle"
  >
    <div 
      class="n-ticker"
      :style="tickerStyle"
    >
      <div class="n-ticker-content">
        <div
          v-for="(logo, index) in logos"
          :key="`original-${index}`"
          class="n-trust-bar-ticker-item"
        >
          <div class="n-trust-bar-ticker-item-content">
            <img
              :src="logo.src"
              :alt="logo.alt"
              loading="lazy"
              decoding="async"
              fetchpriority="auto"
              :width="logo.width"
              :height="logo.height"
            />
          </div>
        </div>
      </div>
      <div 
        class="n-ticker-content" 
        aria-hidden="true"
      >
        <div
          v-for="(logo, index) in logos"
          :key="`duplicate-${index}`"
          class="n-trust-bar-ticker-item"
        >
          <div class="n-trust-bar-ticker-item-content">
            <img
              :src="logo.src"
              :alt="logo.alt"
              loading="lazy"
              decoding="async"
              fetchpriority="auto"
              :width="logo.width"
              :height="logo.height"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

import goLogo from '../assets/logos/go.svg'
import javaLogo from '../assets/logos/java.svg'
import gitLogo from '../assets/logos/git.svg'
import dockerLogo from '../assets/logos/docker.svg'
import jsLogo from '../assets/logos/js.svg'
import kubernetesLogo from '../assets/logos/kubernetes.svg'
import postgresLogo from '../assets/logos/postgresql.svg'

// Logo data - in a real app, this could come from an API or CMS
const logos = [
  { src: goLogo, alt: 'Golang', width: 69, height: 20 },
  { src: javaLogo, alt: 'Java', width: 69, height: 20 },
  { src: gitLogo, alt: 'Git', width: 69, height: 20 },
  { src: dockerLogo, alt: 'Docker', width: 69, height: 20 },
  { src: jsLogo, alt: 'JavaScript', width: 69, height: 20 },
  { src: kubernetesLogo, alt: 'Kubernetes', width: 181, height: 20 },
  { src: postgresLogo, alt: 'Postgres', width: 69, height: 20 },
  // { src: '/images/home/logos/navan.svg', alt: 'Navan', width: 89, height: 20 },
  // { src: '/images/home/logos/contentful.svg', alt: 'Contentful', width: 146, height: 30 },
  // { src: '/images/home/logos/unilever.svg', alt: 'Unilever', width: 62, height: 69 },
  // { src: '/images/home/logos/stack-overflow.svg', alt: 'Stack Overflow', width: 172, height: 34 },
  // { src: '/images/home/logos/riot-games.svg', alt: 'Riot Games', width: 101, height: 28 },
  // { src: '/images/home/logos/nike.svg', alt: 'Nike', width: 80, height: 29 },
  // { src: '/images/home/logos/kubernetes.svg', alt: 'Kubernetes', width: 181, height: 33 },
  // { src: '/images/home/logos/figma.svg', alt: 'Figma', width: 93, height: 35 }
]

// Reactive styles using CSS custom properties
const sectionStyle = computed(() => ({
  '--n-page-section-space-top': 'var(--space-l)',
  '--n-page-section-space-bottom': '0'
}))

const tickerStyle = computed(() => ({
  '--n-ticker-gap': 'var(--space-2xl)',
  '--n-ticker-duration': '50s'
}))
</script>

<style scoped>
.n-page-section {
  padding: var(--n-page-section-space-top, var(--space-l)) 0 var(--n-page-section-space-bottom, 0);
  background: #f8f9fa;
}

.n-breakout {
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
}

.n-ticker {
  display: flex;
  overflow: hidden;
  gap: var(--n-ticker-gap, var(--space-2xl));
  position: relative;
}

.n-ticker-content {
  display: flex;
  align-items: center;
  gap: var(--n-ticker-gap, var(--space-2xl));
  animation: ticker-scroll var(--n-ticker-duration, 50s) linear infinite;
  flex-shrink: 0;
  min-width: 100%;
}

.n-trust-bar-ticker-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.n-trust-bar-ticker-item-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px;
  padding: 30px;
  height: 60px; /* Adjust based on your needs */
}

.n-trust-bar-ticker-item-content img {
  display: block;
  max-width: 100%;
  height: 50px;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.n-trust-bar-ticker-item-content img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

/* Ticker animation */
@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Pause animation on hover */
.n-ticker:hover .n-ticker-content {
  animation-play-state: paused;
}

/* Responsive design */
@media (max-width: 768px) {
  .n-ticker-content {
    animation-duration: 30s; /* Faster on mobile */
  }
  
  .n-trust-bar-ticker-item-content {
    height: 40px;
  }
}
</style>